import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import MainMenu from './components/MainMenu';
import { Layout, Affix, ConfigProvider, theme } from 'antd';
import navigation from './json/navigation.json';
import Nutrient from './components/Nutrients/Nutrient';
import Disease from './components/Disease';
import Home from './components/Home';
import NutriBot from './components/NutriBot';

const { Content } = Layout;

const components = {
  NutriBot: NutriBot,
  Nutrient: Nutrient,
  Disease: Disease,
  Home: Home,
};

function App() {
  const getRoutes = (entries = navigation) => {
    let routes = [];

    for (const entry of entries) {
      if (entry.route) {
        const Component = components[entry.component];
        routes.push(
          <Route
            path={entry.key}
            key={entry.key}
            element={<Component key={`${entry.key}`} path={entry.key} {...entry}></Component>}
          />
        );
      }
      if (entry.children) {
        routes = routes.concat(getRoutes(entry.children));
      }
    }
    routes.push(<Route path="*" element={<Navigate replace to="/" />} />);
    return routes;
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#fff',
          colorBorderSecondary: '#ffe7d6',
          colorBgContainer: 'inherit',
          fontFamily: 'Helvetica',
          colorBgLayout: 'inherit',
          colorText: '#fff',
          fontWeightStrong: '100',
          colorTextDescription: '#fff',
          colorTextLightSolid: '##fff',
          lineWidth: '0',
          colorPrimaryTextActive: '#fff',
          colorIcon: '#fff',
        },
        components: {
          Menu: {
            popupBg: document.body.style.backgroundColor,
            itemPaddingInline: '0px 50px',
          },
          Collapse: {
            headerBg: 'inherit',
          },
        },
      }}>
      <Router>
        <Layout>
          <Affix>
            <MainMenu></MainMenu>
          </Affix>
          <Layout>
            <Content>
              <Routes>{getRoutes()}</Routes>
            </Content>
          </Layout>
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;
